export default "__VITE_ASSET__d3731388__"